import { PropertyPaymentContainer } from 'components/modules/Properties/Details/Payment';

export const PropertyPayment = () => <PropertyPaymentContainer />;
